export const life_LANGUAGE = {
  life_shelf_plan_listing_title: "Shelf Plans",
  life_shelf_plan_listing_add: "Add",
  shelf_plans_list_action_bar_search: "Search",
  life_shelf_plan_name: "Name",
  life_shelf_plan_product_name: "Product Name",
  life_shelf_plan_takaful_provider: "Takaful Provider",
  life_shelf_plan_type: "Type",
  life_shelf_price_type: "Price Type",
  life_shelf_plan_members: "Members",

  life_shelf_plan_about_this_plan_heading: "Heading",
  life_shelf_plan_about_this_plan_video_url: "Video URL",
  life_shelf_plan_add_about_this_plan_label: "Heading",
  life_shelf_plan_add_about_this_plan_placeholder: "Enter Heading",
  life_shelf_plan_add_about_this_plan_label_required_err: "Heading is required",
  life_shelf_plan_add_about_this_plan_label_length_err: "Heading should be under 50 characters",
  life_shelf_plan_add_about_this_plan_description_length_err: "Description should be under 500 characters",

  life_shelf_plan_add_about_this_plan_description_label: "Description",
  life_shelf_plan_add_about_this_plan_label_description_required_err: "Description is required",
  life_shelf_plan_add_about_this_plan_label_description_length_err: "Description should be under 50 characters",

  life_shelf_plan_add_about_this_plan_video_url_label: "Video URL",
  life_shelf_plan_add_about_this_plan_video_url_placeholder: "Enter Website url",

  life_shelf_plan_add_about_this_plan_video_url_required: "Video URL is required",

  life_shelf_plans_add_info_title: "Information",
  life_shelf_plans_add_price_setup_title: "Price Setup",
  life_shelf_plans_add_price_unsaved_data_warning: "You have unsaved data here. Do you want to continue?",
  life_shelf_plans_add_price_unsaved_data_discard_warning: "Your changes will discard. Do you want to continue?",
  life_shelf_plans_add_coverages_title: "Coverages",
  life_shelf_plans_add_services_title: "Services",
  life_shelf_plans_add_documents_title: "Documents",
  life_shelf_plans_add_requiredDocuments_title: "Required Documents",
  life_shelf_plans_add_requiredDocuments_listing_document_name: "Document Name",
  life_shelf_plans_add_requiredDocuments_listing_document_category: "Category",
  life_shelf_plans_add_requiredDocuments_listing_document_supportedFormats: "Supported Formats",
  life_shelf_plans_add_requiredDocuments_modal_name: "Document Name",
  life_shelf_plans_add_requiredDocuments_modal_name_required_error: "Document Name is required",
  life_shelf_plans_add_requiredDocuments_modal_name_length_error: "Document Name should be under 25 characters",
  life_shelf_plans_add_requiredDocuments_modal_name_empty_space_error: "Document Name is invalid",
  life_shelf_plans_add_requiredDocuments_modal_name_special_character_error: "Document Name should not contain special characters or numbers",
  life_shelf_plans_add_requiredDocuments_modal_category: "Category",
  life_shelf_plans_add_requiredDocuments_modal_category_placeholder: "Select Category",
  life_shelf_plans_add_requiredDocuments_modal_category_required_error: "Category is required",
  life_shelf_plans_add_requiredDocuments_modal_supported_format: "Supported Formats",
  life_shelf_plans_add_requiredDocuments_modal_supported_format_required_error: "Supported Format is required",

  life_shelf_plan_listing_add_documents_add_button: "Add Documents",
  life_shelf_plans_add_documents_documents_error: "Select documents is required",
  life_shelf_plans_add_documents_listing_document_name: "Document Name",
  life_shelf_plans_add_documents_select_documents: "Search document",
  life_shelf_plans_add_pre_existing_conditions_title: "Pre-Existing Conditions",
  life_shelf_plans_about_this_plan_title: "About This Plan",
  life_shelf_plans_add_about_this_plan_title: "About This Plan",
  life_shelf_plans_add_plan_exclusion_title: "Plan Exclusion",
  life_shelf_plans_add_coverages_coverages: "Select Coverages",
  life_shelf_plans_add_coverages_coverages_error: "Select Coverages is required",
  life_shelf_plans_add_coverages_description: "Description",
  life_shelf_plans_add_coverages_description_error: "Description is required",
  life_shelf_plans_add_coverages_benefit: "Benefit",
  life_shelf_plans_add_coverages_benefit_error: "Benefit is required",
  life_shelf_plans_add_coverages_description_error_max_length: "Description should be under 2000 characters",

  life_shelf_plans_add_plan_exclusion_exclusion: "Select Exclusion",
  life_shelf_plans_add_plan_exclusion_exclusion_error: "Exclusion is required",
  life_shelf_plans_add_plan_exclusion_description: "Description",
  life_shelf_plans_add_plan_exclusion_description_error: "Description is required",
  life_shelf_plans_add_plan_exclusion_benefit: "Benefit",
  life_shelf_plans_add_plan_exclusion_benefit_error: "Benefit is required",
  life_shelf_plans_add_plan_exclusion_description_error_max_length: "Description should be under 2000 characters",

  life_shelf_plans_add_info_renewal_age_title: "Renewals Only Age (In Yrs)",
  life_shelf_plans_add_info_plan_name: "Plan Name",
  life_shelf_plans_add_info_plan_name_required_error: "Plan name is required",
  life_shelf_plans_add_info_plan_name_length_error: "Plan name must be less than 30 characters",
  life_shelf_plans_add_info_product_name: "Product Name",
  life_shelf_plans_add_info_product_name_required_error: "Product name is required",
  life_shelf_plans_add_info_product_name_length_error: "Product name must be less than 30 characters",
  life_shelf_plans_add_info_plan_type: "Plan Type",
  life_shelf_plans_add_info_plan_type_required_error: "Plan type is required",
  life_shelf_plans_add_info_price_type: "Price Type",
  life_shelf_plans_add_info_price_type_required_error: "Price type is required",
  life_shelf_plans_add_info_line_of_business: "Line of Business",
  life_shelf_plans_add_info_free_service_title: "Free Service",
  life_shelf_plans_add_info_free_service_description: "Option to make the service available at no cost",
  life_shelf_plans_add_info_line_of_business_required_error: "Line of Business is required",
  life_shelf_plans_add_info_takaful_provider: "Takaful Provider",
  life_shelf_plans_add_info_takaful_provider_required_error: "Takaful provider is required",
  life_shelf_plans_add_info_sale_point: "Sale Point",
  life_shelf_plans_add_info_select_member: "Select Member",
  life_shelf_plans_view_info_member: "Members",
  life_shelf_plans_add_info_select_member_required_error: "Member is required",
  life_shelf_plans_add_info_select_gender: "Select Gender",
  life_shelf_plans_view_info_gender: "Gender",
  life_shelf_plans_add_info_select_gender_required_error: "Gender is required",
  life_shelf_plans_add_info_min_age: "Minimum Age",
  life_shelf_plans_add_info_min_age_min_error: "Minimum age must be positive",
  life_shelf_plans_add_info_min_age_max_error: "Minimum age must be lesser than 100",
  life_shelf_plans_add_info_min_age_required_error: "Minimum age is required",
  life_shelf_plans_add_info_max_age: "Maximum Age",
  life_shelf_plans_add_info_max_age_required_error: "Maximum age is required",
  life_shelf_plans_add_info_max_age_min_error: "Maximum age must be positive",
  life_shelf_plans_add_info_max_age_max_error: "Maximum age must be lesser than 100",
  life_shelf_plans_add_info_max_age_greater_than_min_age_error: "Maximum age must be greater than minimum age",

  life_shelf_plans_coverage_coverage_type: "Coverage Type",
  life_shelf_plans_coverage_benefit_value: "Benefit Value",
  life_shelf_plans_coverage_sub_child: "Sub-Child",

  life_shelf_plans_add_info_number_of_children: "No. of children",
  life_shelf_plans_add_info_number_of_children_required_error: "No. of children is required",
  life_shelf_plans_add_info_number_of_children_max_error: "No. of children must be lesser than or equal to 4",
  life_shelf_plans_add_info_number_of_children_min_error: "No. of children must be greater than 0",

  life_shelf_plans_listing_plan_exclusion_title: "Plan Exclusion",
  life_shelf_plans_listing_plan_exclusion_exclusion_type: "Exclusion Type",
  life_shelf_plans_listing_plan_exclusion_exclusion_value: "Exclusion Value",
  life_shelf_plans_listing_plan_exclusion_sub_child: "Sub-Child",

  life_shelf_plans_pre_existing_conditions_listing_title: "Pre-Existing Conditions",
  life_shelf_plans_pre_existing_conditions_listing_add: "Add PEC",
  life_shelf_plans_pre_existing_conditions_listing_year_range: "Year Range",
  life_shelf_plans_pre_existing_conditions_listing_condition: "Condition (%)",
  life_shelf_plans_pre_existing_conditions_listing_description: "Description",
  life_shelf_plans_pre_existing_conditions_add_title: "Pre-Existing Conditions",
  life_shelf_plans_pre_existing_conditions_add_year_range: "Year Range",
  life_shelf_plans_pre_existing_conditions_add_year_range_min_error: "Date Range (Min) is required",
  life_shelf_plans_pre_existing_conditions_add_year_range_min_error_min_limit: "Date Range (Min) can't be less than 1",
  life_shelf_plans_pre_existing_conditions_add_year_range_max_error_min_limit: "Date Range (Max) can't be less than 1",
  life_shelf_plans_pre_existing_conditions_add_year_range_min_error_min_year_limit: "Date Range (Min) can't be more than 1 digit",
  life_shelf_plans_pre_existing_conditions_add_year_range_min_error_more_than_two: "Date Range (Min) can't be more than 2 digit",
  life_shelf_plans_pre_existing_conditions_add_year_range_max_error_max_year_limit: "Date Range (Max) can't be more than 2 digit",
  life_shelf_plans_pre_existing_conditions_add_year_range_min_error_max_days_limit: "Date Range (Min) can't be more than 365",
  life_shelf_plans_pre_existing_conditions_add_year_range_max_error_max_days_limit: "Date Range (Max) can't be more than 365",
  life_shelf_plans_pre_existing_conditions_add_year_range_min_error_decimal: "Date Range (Min) can't be decimal",
  life_shelf_plans_pre_existing_conditions_add_year_range_max_error_decimal: "Date Range (Max) can't be decimal",
  life_shelf_plans_pre_existing_conditions_add_year_range_max_error_min_year_and_max_day:
    "Date Range (Max) can't be days if Date Range (Min) is year",
  life_shelf_plans_pre_existing_conditions_add_year_range_max_error: "Date Range (Max) is required",
  life_shelf_plans_pre_existing_conditions_add_year_range_min_error_greater_than_year_range_max:
    "Date Range (Min) should be less than Date Range (Max)",
  life_shelf_plans_pre_existing_conditions_add_year_condition: "Condition",
  life_shelf_plans_pre_existing_conditions_add_year_condition_error: "Condition is required",
  life_shelf_plans_pre_existing_conditions_add_condition_error_min_limit: "Condition can't be less than 0",
  life_shelf_plans_pre_existing_conditions_add_condition_error_max_percentage_limit: "Condition can't be greater than 100",
  life_shelf_plans_pre_existing_conditions_add_condition_error_decimal: "Condition can't be decimal",
  life_shelf_plans_pre_existing_conditions_add_year_description: "Description",
  life_shelf_plans_pre_existing_conditions_add_year_description_error_max_length: "Description should be under 250 characters",
  life_shelf_plans_add_price_setup_annual_pricing_title: "Annual Pricing",
  life_shelf_plans_add_price_setup_monthly_pricing_title: "Monthly Pricing",
  life_shelf_plans_add_price_setup_incentive_title: "Incentive",
  life_shelf_plans_add_price_setup_incentive_min: "Incentive(Min)",
  life_shelf_plans_add_price_setup_incentive_max: "Incentive(Max)",
  life_shelf_plans_add_price_setup_built_in_incentive: "Built-in Incentive",
  life_shelf_plans_add_price_setup_base_rate: "Base Rate",
  life_shelf_plans_add_price_setup_one_month_installment_range: "1 Month Installment Range",
  life_shelf_plans_add_price_setup_eleven_month_installment_range: "11 Month Installment Range",
  life_shelf_plans_add_price_setup_admin_cost_title: "Admin Cost",
  life_shelf_plans_add_price_setup_pricing_title: "Pricing",
  life_shelf_plans_add_price_setup_add_row: "Add Row",
  life_shelf_plans_add_price_setup_listing_age_bracket: "Age Bracket",
  life_shelf_plans_add_price_setup_listing_listing_price: "Listing Price",
  life_shelf_plans_add_price_setup_listing_total_admin_and_taxes: "Total Admin & Taxes",
  life_shelf_plans_add_price_setup_listing_gross_contribution: "Gross Contribution",
  life_shelf_plans_add_price_setup_listing_incentive_range: "Incentive Range",
  life_shelf_plans_add_price_setup_listing_selling_price_range: "Selling Price Range",

  life_shelf_plans_add_price_setup_incentive_min_required_error: "Minimum-Incentive is required",
  life_shelf_plans_add_price_setup_incentive_min_maximum_error_in_percentage: "Minimum-Incentive must be equal to or less than two digits",
  life_shelf_plans_add_price_setup_incentive_min_minimum_error_in_percentage: "Minimum-Incentive must be positive",
  life_shelf_plans_add_price_setup_incentive_min_minimum_decimal_error_in_percentage: "Minimum-Incentive must not contain more than 2 decimal points",
  life_shelf_plans_add_price_setup_incentive_min_maximum_error_in_non_percentage: "Minimum-Incentive must be equal to or less than five digits",
  life_shelf_plans_add_price_setup_incentive_min_decimal_error_in_non_percentage: "Minimum-Incentive must not contain decimal points",

  life_shelf_plans_add_price_setup_incentive_max_required_error: "Maximum-Incentive is required",
  life_shelf_plans_add_price_setup_incentive_max_minimum_error_in_percentage: "Maximum-Incentive must be positive",
  life_shelf_plans_add_price_setup_incentive_max_maximum_error_in_percentage: "Maximum-Incentive must be equal to or less than two digits",
  life_shelf_plans_add_price_setup_incentive_max_minimum_decimal_error_in_percentage: "Maximum-Incentive must contain only 2 decimal points",
  life_shelf_plans_add_price_setup_incentive_max_decimal_error_in_non_percentage: "Maximum-Incentive must contain only 2 decimal points",
  life_shelf_plans_add_price_setup_incentive_max_maximum_error_in_non_percentage: "Maximum-Incentive must be equal to or less than five digits",
  life_shelf_plans_add_price_setup_incentive_max_greater_than_min_error: "Maximum-Incentive must be equal to or greater than  Minimum-Incentive",
  life_shelf_plans_add_price_setup_incentive_max_value_type_id_different_from_incentive_min_type_id_err:
    "Maximum-Incentive Provision type must be same as Minimum-Incentive Provision type",
  life_shelf_plans_add_price_setup_provision_type_required_error: "Provision type is required",
  life_shelf_plans_add_price_setup_incentive_max_value_different_from_incentive_min_value_in_digital_sell_point_err:
    "Maximum-Incentive must be equal to Minimum-Incentive in Digital Sell Point",

  life_shelf_plans_add_price_setup_incentive_built_in_required_error: "Built-In Incentive is required",
  life_shelf_plans_add_price_setup_incentive_built_in_maximum_error_in_percentage:
    "Built-In Incentive  must be must be equal to or less than two digits",
  life_shelf_plans_add_price_setup_incentive_built_in_minimum_decimal_error_in_percentage: "Built-In Incentive must be contain only 2 decimal points",
  life_shelf_plans_add_price_setup_incentive_built_in_maximum_error_in_non_percentage: "Built-In Incentive must be equal to or less than Six digits",
  life_shelf_plans_add_price_setup_incentive_built_in_decimal_error_in_non_percentage: "Built-In Incentive must contain two decimal points",
  life_shelf_plans_add_price_setup_incentive_built_in_minimum_error_in_percentage: "Built-In Incentive must be positive",

  life_shelf_plans_add_price_setup_min_admin_cost_required_error: "Minimum Admin Cost is required",
  life_shelf_plans_add_price_setup_min_admin_cost_minimum_error_in_percentage: "Minimum Admin Cost must be positive",
  life_shelf_plans_add_price_setup_min_admin_cost_maximum_error_in_percentage: "Minimum Admin Cost must be must be equal to or less than two digits",
  life_shelf_plans_add_price_setup_min_admin_cost_minimum_decimal_error_in_percentage: "Minimum Admin cost can be contain 2 decimal points",
  life_shelf_plans_add_price_setup_min_admin_cost_maximum_error_in_non_percentage: "Minimum Admin Cost must be equal to or less than Five digits",
  life_shelf_plans_add_price_setup_min_admin_cost_decimal_error_in_non_percentage: "Minimum Admin Cost must contain two decimals",

  life_shelf_plans_add_price_setup_max_admin_cost_required_error: "Maximum Admin Cost is required",
  life_shelf_plans_add_price_setup_max_admin_cost_minimum_error_in_percentage: "Maximum Admin Cost must be positive",
  life_shelf_plans_add_price_setup_max_admin_cost_maximum_error_in_percentage: "Maximum Admin Cost must be must be equal to or less than two digits",
  life_shelf_plans_add_price_setup_max_admin_cost_minimum_decimal_error_in_percentage: "Maximum Admin cost can be contain 2 decimal points",
  life_shelf_plans_add_price_setup_max_admin_cost_maximum_error_in_non_percentage: "Maximum Admin Cost must be equal to or less than Five digits",
  life_shelf_plans_add_price_setup_max_admin_cost_decimal_error_in_non_percentage: "Maximum Admin Cost must not contain more than two decimals",
  life_shelf_plans_add_price_setup_max_admin_cost_value_type_id_different_from_min_admin_cost_value_type_id_err:
    "Maximum Admin Cost Provision type must be same as Minimum Admin Cost Provision type",
  life_shelf_plans_add_price_setup_max_admin_cost_greater_than_min_error: "Maximum Admin Cost must be equal to or greater than  Minimum Admin Cost",

  life_shelf_plans_add_price_setup_grid_min_age_required_error: "Minimum Age is required",
  life_shelf_plans_add_price_setup_grid_duration_type_required_error: "Duration type is required",
  life_shelf_plans_add_price_setup_grid_min_age_minimum_error_in_year: "Minimum Age must be positive",
  life_shelf_plans_add_price_setup_grid_min_age_maximum_error_in_year: "Minimum Age must be must be equal to or less than two digits",
  life_shelf_plans_add_price_setup_grid_min_age_decimal_error: "Minimum Age must not contain decimal",
  life_shelf_plans_add_price_setup_min_age_maximum_digits_error_in_days: "Minimum Age must be equal to or less than Three digits",
  life_shelf_plans_add_price_setup_min_age_maximum_value_error_in_days: "Minimum Age must be equal to or less than 365",

  life_shelf_plans_add_price_setup_grid_max_age_required_error: "Maximum Age is required",
  life_shelf_plans_add_price_setup_grid_max_age_minimum_error_in_year: "Maximum Age must be positive",
  life_shelf_plans_add_price_setup_grid_max_age_decimal_error: "Maximum Age must not contain decimal",
  life_shelf_plans_add_price_setup_grid_max_age_maximum_error_in_year: "Maximum Age must be must be equal to or less than two digits",
  life_shelf_plans_add_price_setup_max_age_maximum_digits_error_in_days: "Maximum Age must be equal to or less than Three digits",
  life_shelf_plans_add_price_setup_max_age_maximum_value_error_in_days: "Maximum Age must be equal to or less than 365",
  life_shelf_plans_add_price_setup_max_age_range_conflict_error: "This Age Range is conflicting",

  life_shelf_plans_add_price_setup_max_age_value_type_id_different_from_min_age_value_type_id_err:
    "Maximum Age Duration type must be same as Minimum Age Duration type",
  life_shelf_plans_add_price_setup_max_age_greater_than_min_error: "Maximum Age must be equal to or greater than  Minimum Age",

  life_shelf_plans_add_price_setup_grid_listing_price_required_error: "Listing Price is required",
  life_shelf_plans_add_price_setup_grid_listing_price_minimum_error: "Listing Price must be positive",
  life_shelf_plans_add_price_setup_grid_listing_price_maximum_error_in_percentage: "Listing Price must be equal to or less than two digits",
  life_shelf_plans_add_price_setup_grid_listing_price_minimum_decimal_error_in_percentage: "Listing Price must be contain decimal points",
  life_shelf_plans_add_price_setup_grid_listing_price_maximum_error_in_non_percentage: "Listing Price must be equal to or less than Six digits",

  life_shelf_plans_sale_point: "Sale Point",
  life_shelf_plans_select_sale_point: "Select Salepoint",
  life_shelf_plans_select_sale_point_error: "Please select salePoint",

  life_shelf_plans_services_listing_title: "Services",
  life_shelf_plans_services_listing_priority_order: "Priority Order",
  life_shelf_plans_services_listing_service_name: "Service Name",
  life_shelf_plans_services_listing_provider_name: "Provider Name",
  life_shelf_plans_services_listing_sub_services: "Sub-Services",

  life_order_listing_title: "Life Orders",
  life_order_download_as_zip: "Download as ZIP",
  life_order_download_export_to_excel: "Export to Excel",
  life_order_listing_order_date: "Order Date",
  life_order_listing_order_id: "Order Id",
  life_order_listing_name: "Name",
  life_order_listing_sale_point: "Sale Point",
  life_order_listing_plan_name: "Plan Name",
  life_order_listing_plan_type: "Plan Type",
  life_order_listing_contribution: "Contribution",
  life_order_listing_payment_frequency: "Payment Frequency",
  life_order_listing_source: "Source",
  life_order_listing_payment_status: "Payment Status",
  life_order_listing_policy_status: "Policy Status",
  life_order_listing_policy_id: "Policy ID",
  life_order_listing_takaful_provider: "Takaful Provider",
  life_order_listing_services_provider: "Services Provider",
  life_order_listing_services: "Services",
  life_order_listing_product_name: "Product Name",
  life_order_listing_policy_issue_date: "Policy Issue Date",
  life_order_listing_policy_expiry_date: "Policy Expiry Date",
  life_order_listing_last_updated: "Last Updated",
  life_order_personal_details: "Personal Details",
  life_order_proposer_details: "Proposer Details",
  life_order_proposer_details_title: "Proposer Details",
  life_order_member_details: "Member Details",
  life_order_plan_details: "Plan Details",
  life_order_documents: "Documents",
  life_order_payment: "Payment",
  life_order_activity_log: "Activity Log",
  life_order_customer_details: "Customer Details",
  life_order_proposer_details_edit: "Edit",
  life_order_name: "Name",
  life_order_date_of_birth: "Date of Birth",
  life_order_place_of_birth: "Place of Birth",
  life_order_cnic_number: "CNIC Number",
  life_order_cnic_issue_date: "CNIC Issue Date",
  life_order_cnic_expiry_date: "CNIC Expiry Date",
  life_order_cnic_marital_status: "Marital Status",
  life_order_occupation: "Occupation",
  life_order_contact_details: "Contact Details",
  life_order_contact_number: "Contact Number",
  life_order_email_address: "Email Address",
  life_order_address: "Address",
  life_order_permanent_address: "Permanent Address",
  life_order_current_address: "Current Address",
  life_order_city: "City",
  life_order_name_error: "Name is required",
  life_order_name_validation_error: "Invalid Name",
  life_order_name_length_error: "Name must be smaller than 35 characters",
  life_order_date_of_birth_error: "Date of Birth is required",
  life_order_cnic_error: "CNIC is required",
  life_order_cnic_length_error: "CNIC Number should be 13 digits only",
  life_order_cnic_issue_date_error: "CNIC issue date is required",
  life_order_cnic_expiry_date_error: "CNIC expiry date is required",
  life_order_cnic_issue_date_before_expiry_date_error: "CNIC Issue date should be before expiry date",
  life_order_cnic_issue_date_five_year_before_expiry_date_error: "CNIC Expiry date should be at least 5 years after CNIC issue date",
  life_order_date_of_birth_before_cnic_issue_date_error: "Date of birth should be before CNIC issue date",
  life_order_cnic_issue_date_eighteen_year_before_cnic_issue_date_error: "CNIC Issue date should be at least 18 years after date of birth",
  life_order_cnic_cnic_life_time_expiry: "Lifetime",
  life_order_cnic_validation_error: "Incorrect format i.e 12345-4567896-6",
  life_order_cnic_number_placeholder: "12345-4567896-6",
  life_order_marital_status_error: "Martial status is required",
  life_order_occupation_error: "Occupation is required",
  life_order_occupation_length_error: "Occupation must be smaller than 35 characters",
  life_order_contact_number_error: "Contact number is required",
  life_order_email_error: "Email Address is required",
  life_order_email_validation: "Invalid Email",
  life_order_permanent_address_error: "Permanent Address is required",
  life_order_current_address_error: "Current Address is required",
  life_order_permanent_address_length_error: "Permanent Address must be smaller than 100 characters",
  life_order_current_address_length_error: "Current Address must be smaller than 100 characters",
  life_order_city_error: "City is required",
  life_order_same_as_permanent_address: "Same as permanent address",
  life_order_occupation_validation_error: "Invalid Occupation",
  life_order_holder_of_any_government_office: "Holder of any Government Office",
  life_order_life_time: "Life time",
  life_order_edit_holder_of_any_government_office: "Holder of any Government Office",

  life_order_member_details_edit: "Edit",
  life_order_spouse_details: "Spouse Details",
  life_order_full_name: "Full Name",
  life_order_child_details: "Child Details",
  life_order_child: "Child",
  life_order_relation: "Relation",
  life_order_relation_error: "Relation is required",
  life_order_child_name_error: "Child name is required",
  life_order_child_name_validation_error: "Invalid Child Name",
  life_order_child_date_of_birth_error: "Child Date of Birth is required",
  life_order_child_relation_error: "Child relation is required",
  life_order_child_name_length_error: "Child name must be smaller than 35 characters",
  life_order_member_details_father_details: "Father Details",
  life_order_member_details_mother_details: "Mother Details",
  life_order_edit_member_details_father_details: "Father Details",
  life_order_edit_member_details_mother_details: "Mother Details",

  life_order_plan_details_takaful_provider_details: "Takaful Provider Details",
  life_order_plan_details_takaful_provider_name: "Takaful Provider Name",
  life_order_plan_details_plan_name: "Plan Name",
  life_order_plan_details_product_name: "Product Name",
  life_order_plan_details_policy_id: "Policy ID",
  life_order_plan_details_policy_issue_date: "Policy Issue Date",
  life_order_plan_details_policy_expiry_date: "Policy Expiry Date",
  life_order_plan_details_services: "Services",
  life_order_plan_details_med_iq: "Med IQ",
  life_order_plan_details_service_provider_2: "Service Provider 2",
  life_order_plan_details_service_provider_3: "Service Provider 3",
  life_order_plan_details_payment: "Payment",
  life_order_plan_details_payment_frequency: "Payment Frequency",
  life_order_plan_details_total_contribution: "Total Contribution",
  life_order_plan_details_1st_month_installment: "1st Month Installment",
  life_order_plan_details_11_months_installment: "11 Months Installment",
  life_order_plan_details_service_provider: "Service Provider",
  life_order_plan_details_price: "Price",
  life_order_plan_details_service: "Service",

  life_order_documents_title: "Documents",
  life_order_download_all_as_zip: "Download all as ZIP",
  life_order_upload_documents: "Uploaded Document",
  life_order_upload_type: "Document Type",
  life_order_last_updated: "Last Updated",
  life_order_non_editable_document: "Cannot Edit _DOCUMENT_TYPE_",

  life_order_edit_documents_name: "Document Name",
  life_order_edit_documents_name_error: "Document name is required",
  life_order_edit_documents_name_length_error: "Document name must be smaller than 50 characters",

  life_order_edit_documents_policy_id: "Policy ID",
  life_order_edit_documents_policy_id_error: "Policy id is required",
  life_order_edit_documents_policy_issue_date: "Policy Issue Date",
  life_order_edit_documents_policy_expiry_date: "Policy Expiry Date",
  life_order_edit_documents_policy_issue_date_error: "CNIC issue date is required",
  life_order_edit_documents_policy_expiry_date_error: "CNIC expiry date is required",
  life_order_edit_documents_policy_id_length_error: "Policy id must be smaller than 20 characters",
  life_order_edit_documents_policy_id_validation_error: "Special characters are not allowed",

  life_order_edit_documents_doc_type: "Documents Type",
  life_order_edit_documents_doc_type_error: "Document type is required",
  life_order_add_documents_upload_error: "Upload document is required",
  life_order_add_documents_upload_document: "Upload Document",
  life_order_add_documents_upload_text: "Upload",
  life_order_add_documents_last_updated_text: "Last Updated",

  life_order_payment_title: "Payment",
  life_order_payment_month: "Month",
  life_order_payment_method: "Payment Method",
  life_order_payment_status: "Payment Status",
  life_order_payment_contribution: "Contribution",
  life_order_payment_payment_status: "Payment Status",
  life_order_payment_last_updated: "Last Updated",
  life_order_payment_period: "Period",

  life_order_edit_payment_title: "Payment",
  life_order_edit_payment_error: "Payment is required",

  life_order_view_payment_title: "Payment",
  life_order_view_payment_details_title: "Payment Details",
  life_order_view_payment_details_total_contribution: "Total Contribution",
  life_order_view_payment_details_frequency: "Frequency",
  life_order_view_payment_details_payment_method: "Payment Method",
  life_order_view_payment_services_title: "Services",
  life_order_view_payment_med_iq: "Med IQ",
  life_order_view_payment_provider_2: "Provider 2",

  life_order_view_payment_contact_details_title: "Contact Details",
  life_order_view_payment_pick_up_address: "Pick Up Address",
  life_order_view_payment_contact_number: "Contact Number",

  life_order_view_payment_status_title: "Payment Status",
  life_order_view_payment_month: "Month",
  life_order_view_payment_amount: "Amount",
  life_order_view_payment_status: "Status",

  life_order_activity_log_heading: "Activity log",
  life_shelf_plans_edit_service_annual_pricing_title: "Annual Pricing",
  life_shelf_plans_edit_service_monthly_pricing_title: "Monthly Pricing",
  life_shelf_plans_edit_service_incentive_title: "Incentive",
  life_shelf_plans_edit_service_incentive_min: "Incentive(Min)",
  life_shelf_plans_edit_service_incentive_max: "Incentive(Max)",
  life_shelf_plans_edit_service_built_in_incentive: "Built-in Incentive",
  life_shelf_plans_edit_service_base_rate: "Base Rate",
  life_shelf_plans_edit_service_one_month_installment_range: "1 Month Installment Range",
  life_shelf_plans_edit_service_eleven_month_installment_range: "11 Month Installment Range",
  life_shelf_plans_edit_service_admin_cost_title: "Admin Cost",
  life_shelf_plans_edit_service_pricing_title: "Pricing",
  life_shelf_plans_edit_service_add_row: "Add Row",
  life_shelf_plans_edit_service_listing_age_bracket: "Age Bracket",
  life_shelf_plans_edit_service_listing_listing_price: "Listing Price",
  life_shelf_plans_edit_service_listing_total_admin_and_taxes: "Total Admin & Taxes",
  life_shelf_plans_edit_service_listing_gross_contribution: "Gross Contribution",
  life_shelf_plans_edit_service_listing_incentive_range: "Incentive Range",
  life_shelf_plans_edit_service_listing_selling_price_range: "Selling Price Range",

  life_shelf_plans_edit_service_incentive_min_required_error: "Input field is required",
  life_shelf_plans_edit_service_incentive_min_maximum_error_in_percentage: "Minimum-Incentive must be equal to or less than two digits",
  life_shelf_plans_edit_service_incentive_min_minimum_error_in_percentage: "Negative Values are not allowed",
  life_shelf_plans_edit_service_incentive_min_minimum_decimal_error_in_percentage: "Minimum-Incentive must contain only 2 decimal points",
  life_shelf_plans_edit_service_incentive_min_maximum_error_in_non_percentage: "Minimum-Incentive must be equal to or less than five digits",
  life_shelf_plans_edit_service_incentive_min_decimal_error_in_non_percentage: "Must be equal or less than two decimals ",

  life_shelf_plans_edit_service_incentive_max_required_error: "Input field is required",
  life_shelf_plans_edit_service_incentive_max_minimum_error_in_percentage: "Negative Values are not allowed",
  life_shelf_plans_edit_service_incentive_max_maximum_error_in_percentage: "Maximum-Incentive must be equal to or less than two digits",
  life_shelf_plans_edit_service_incentive_max_minimum_decimal_error_in_percentage: "Maximum-Incentive must be contain only 2 decimal points",
  life_shelf_plans_edit_service_incentive_max_decimal_error_in_non_percentage: "Must contain only 2 decimal points",
  life_shelf_plans_edit_service_incentive_max_maximum_error_in_non_percentage: "Maximum-Incentive must be equal to or less than five digits",
  life_shelf_plans_edit_service_incentive_max_greater_than_min_error: "Maximum-Incentive must be equal to or greater than  Minimum-Incentive",
  life_shelf_plans_edit_service_incentive_max_value_type_id_different_from_incentive_min_type_id_err:
    "Maximum-Incentive Provision type must be same as Minimum-Incentive Provision type",
  life_shelf_plans_edit_service_incentive_max_value_different_from_incentive_min_value_in_digital_sell_point_err:
    "Maximum-Incentive must be equal to Minimum-Incentive in Digital Sell Point",

  life_shelf_plans_edit_service_incentive_built_in_required_error: "Input field is required",
  life_shelf_plans_edit_service_incentive_built_in_maximum_error_in_percentage:
    "Built-In Incentive  must be must be equal to or less than two digits",
  life_shelf_plans_edit_service_incentive_built_in_minimum_decimal_error_in_percentage: "Built-In Incentive must be contain only 2 decimal points",
  life_shelf_plans_edit_service_incentive_built_in_maximum_error_in_non_percentage: "Built-In Incentive must be equal to or less than Six digits",
  life_shelf_plans_edit_service_incentive_built_in_decimal_error_in_non_percentage: "Must be equal or less than two decimals",
  life_shelf_plans_edit_service_incentive_built_in_minimum_error_in_percentage: "Negative Values are not allowed",

  life_shelf_plans_edit_service_min_admin_cost_required_error: "Input field is required",
  life_shelf_plans_edit_service_min_admin_cost_minimum_error_in_percentage: "Negative Values are not allowed",
  life_shelf_plans_edit_service_min_admin_cost_maximum_error_in_percentage: "Minimum Admin Cost must be must be equal to or less than two digits",
  life_shelf_plans_edit_service_min_admin_cost_minimum_decimal_error_in_percentage: "Minimum Admin cost can be contain 2 decimal points",
  life_shelf_plans_edit_service_min_admin_cost_maximum_error_in_non_percentage: "Minimum Admin Cost must be equal to or less than Five digits",
  life_shelf_plans_edit_service_min_admin_cost_decimal_error_in_non_percentage: "Must be equal or less than two decimals ",

  life_shelf_plans_edit_service_max_admin_cost_required_error: "Input field is required",
  life_shelf_plans_edit_service_max_admin_cost_minimum_error_in_percentage: "Negative Values are not allowed",
  life_shelf_plans_edit_service_max_admin_cost_maximum_error_in_percentage: "Maximum Admin Cost must be must be equal to or less than two digits",
  life_shelf_plans_edit_service_max_admin_cost_minimum_decimal_error_in_percentage: "Maximum Admin cost can be contain 2 decimal points",
  life_shelf_plans_edit_service_max_admin_cost_maximum_error_in_non_percentage: "Maximum Admin Cost must be equal to or less than Five digits",
  life_shelf_plans_edit_service_max_admin_cost_decimal_error_in_non_percentage: "Must be equal or less than two decimals ",
  life_shelf_plans_edit_service_max_admin_cost_value_type_id_different_from_min_admin_cost_value_type_id_err:
    "Maximum Admin Cost Provision type must be same as Minimum Admin Cost Provision type",
  life_shelf_plans_edit_service_max_admin_cost_greater_than_min_error: "Maximum Admin Cost must be equal to or greater than  Minimum Admin Cost",

  life_shelf_plans_edit_service_grid_min_age_required_error: "Input field is required",
  life_shelf_plans_edit_service_grid_min_age_minimum_error_in_year: "Negative values are not allowed",
  life_shelf_plans_edit_service_grid_min_age_maximum_error_in_year: "Minimum Age must be must be equal to or less than two digits",
  life_shelf_plans_edit_service_grid_min_age_decimal_error: "Decimal values are not allowed",
  life_shelf_plans_edit_service_min_age_maximum_digits_error_in_days: "Minimum Age must be equal to or less than Three digits",
  life_shelf_plans_edit_service_min_age_maximum_value_error_in_days: "Minimum Age must be equal to or less than 365",

  life_shelf_plans_edit_service_grid_max_age_required_error: "Input field is required",
  life_shelf_plans_edit_service_grid_max_age_minimum_error_in_year: "Negative values are not allowed",
  life_shelf_plans_edit_service_grid_max_age_decimal_error: "Decimal values are not allowed",
  life_shelf_plans_edit_service_grid_max_age_maximum_error_in_year: "Maximum Age must be must be equal to or less than two digits",
  life_shelf_plans_edit_service_max_age_maximum_digits_error_in_days: "Maximum Age must be equal to or less than Three digits",
  life_shelf_plans_edit_service_max_age_maximum_value_error_in_days: "Maximum Age must be equal to or less than 365",
  life_shelf_plans_edit_service_max_age_value_type_id_different_from_min_age_value_type_id_err:
    "Maximum Age Duration type must be same as Minimum Age Duration type",
  life_shelf_plans_edit_service_max_age_greater_than_min_error: "Maximum Age must be equal to or greater than  Minimum Age",
  life_shelf_plans_edit_service_max_age_duration_not_same_min_age_duration_error_in_days:
    "Maximum Age duration type must be same as Minimum age duration type",

  life_shelf_plans_edit_service_max_age_range_conflict_error: "Duplicate entry",

  life_shelf_plans_edit_service_grid_listing_price_required_error: "Input field is required",
  life_shelf_plans_edit_service_grid_listing_price_minimum_error: "Negative values are not allowed",
  life_shelf_plans_edit_service_grid_listing_price_maximum_error_in_percentage: "Listing Price must be equal to or less than two digits",
  life_shelf_plans_edit_service_grid_listing_price_minimum_decimal_error_in_percentage: "Listing Price must not contain decimals",
  life_shelf_plans_edit_service_grid_listing_price_maximum_error_in_non_percentage: "Listing Price must be equal to or less than seven digits",
  life_shelf_plans_edit_service_grid_listing_price_decimal_error_in_non_percentage: "Decimal values are not allowed",
  management_service_add_price_setup_max_age_range_conflict_error: "Duplicate Entry",

  life_shelf_plans_edit_service_duration_type_required_error: "Duration type is required",
  life_shelf_plans_edit_service_provision_type_required_error: "Provision type is required",

  life_shelf_plans_add_service_select_provider: "Select Provider",
  life_shelf_plans_add_service_select_provider_required_error: "Select Provider is required",
  life_shelf_plans_add_service_select_provider_takaful_provider: "Takaful Provider",
  life_shelf_plans_add_service_select_provider_service_provider: "Service Provider",
  life_shelf_plans_add_service_search_service: "Search Service",
  life_shelf_plans_add_service_search_service_required_error: "Search Service is required",
  life_shelf_plans_add_service_service_heading: "Service",
  life_shelf_plans_add_service_sub_service_heading: "Sub Service",
  life_shelf_plans_add_service_title: "Add Service"
};
